export const GoogleWorkspaceAppTypeDecorator = {
  url() {
    return `signup-hubspot/integrations`;
  },
  query() {
    return {
      integration: 'google-workspace-app'
    };
  }
};